import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';

import { ResultType } from '../types/result.types.ts';
import { getReadingCrittersClientUtil } from '../utils/clients/readingcritters.client.util.ts';

export const TEXT_TO_CHARACTER_SPEECH = mutation({
  textToCharacterSpeech: [{ input: input('input', 'TextToCharacterSpeechInput!') }, { id: true }],
});

type TextToCharacterSpeechMutationVariables = VariablesOf<typeof TEXT_TO_CHARACTER_SPEECH>['input'];
type TextToCharacterSpeechMutationResult = ResultOf<typeof TEXT_TO_CHARACTER_SPEECH>['textToCharacterSpeech'];

export const textToCharacterSpeechMutationRequest = async (
  props: TextToCharacterSpeechMutationVariables
): Promise<ResultType<TextToCharacterSpeechMutationResult>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.mutation(TEXT_TO_CHARACTER_SPEECH, { input: props }, { useAuth: true });

  return {
    success: Boolean(response?.textToCharacterSpeech?.id),
    data: response?.textToCharacterSpeech ?? { id: '' },
  };
};
